import { createSelector } from '@reduxjs/toolkit';

export const groupSelector = (state: ReduxState) => state.groupReducer;
export const getGroup = createSelector(groupSelector, (group) => group.group);
